import * as React from 'react'
import { MatchCreateNewButton } from '../MatchCreateNew'
import { LocationInfoTagProps } from './typings'
import { LocationLink } from './LocationLink'

export const LocationInfoTag: React.FC<LocationInfoTagProps> = (props) =>
  props.externalLocationId !== '' ? (
    <LocationLink {...props} />
  ) : (
    <MatchCreateNewButton {...props} />
  )
LocationInfoTag.displayName = 'LocationInfoTag'
